// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import counterReducer from './slices/counter';
import flagReducer from './slices/flag';
import eventAttendance from './slices/eventAttendance';
import Demovideo from './slices/Demovideo';
import Profile from './slices/profile';
import Timerupdate from './slices/timer';
import qicReducer from './slices/qic';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'Dhruva-'
        },
        cartReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    counter:counterReducer,
    flag:flagReducer,
    attendance:eventAttendance,
    demovideolink:Demovideo,
    profile:Profile,
    timerupdate : Timerupdate,
     qic: qicReducer
});

export default reducer;
